import {INotificationsState, notificationsSlice as notificationsSliceTemplate} from "@pg-design/ds-store";

export const notificationsSlice = notificationsSliceTemplate;

export const {addNotification, removeNotification, dropAllTtlAndRemoveInvalid} = notificationsSlice.actions;

export type INotificationValues = ReturnType<typeof addNotification>["payload"];

export type {INotificationsState};
import {INotificationsState, notificationsSlice as notificationsSliceTemplate} from "@pg-design/ds-store";

export const notificationsSlice = notificationsSliceTemplate;

export const {addNotification, removeNotification, dropAllTtlAndRemoveInvalid} = notificationsSlice.actions;

export type INotificationValues = ReturnType<typeof addNotification>["payload"];

export type {INotificationsState};
